import { InputLabel, MenuItem } from '@mui/material';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { PresenceRefetchInterval } from '../CurrentPresence.types';
import { PRESENCE_REFETCH_INTERVAL_LABELS, PRESENCE_REFETCH_INTERVALS } from '../CurrentPresence.variables';

import { PresenceRefreshSelectProps } from './PresenceRefreshSelect.types';
import * as Styled from './PresenceRefreshSelect.styles';

/** "Odświeżanie" 3 / 5 / 10 s — shared by the zone tree and the people list. */
export const PresenceRefreshSelect = ({ refetchInterval, setRefetchInterval }: PresenceRefreshSelectProps) => {
  const { formatMessage } = useLocale();

  return (
    <Styled.RefreshSelectFormControl variant="filled">
      <InputLabel focused={false}>{formatMessage({ id: AppMessages['events.refresh'] })}</InputLabel>
      <Styled.RefreshSelect
        variant="outlined"
        value={refetchInterval}
        onChange={(e) => setRefetchInterval(Number(e.target.value) as PresenceRefetchInterval)}
      >
        {PRESENCE_REFETCH_INTERVALS.map((interval) => (
          <MenuItem key={interval} value={interval}>
            {formatMessage({ id: PRESENCE_REFETCH_INTERVAL_LABELS[interval] })}
          </MenuItem>
        ))}
      </Styled.RefreshSelect>
    </Styled.RefreshSelectFormControl>
  );
};
